import { get } from "lodash";
export default (function (deal) { return (!!get(deal, "productConfig.limits.forOpenValue.minValue", null) && !!get(deal, "productConfig.limits.forOpenValue.maxValue", null)); });
